//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { CustomAction } from 'components/custom-action/types';
import { CustomActionPythonPayload } from 'store/custom-action-python/types';
import { HeadersPayload } from 'store/custom-action/types';

export const makeCustomActionPayload = (params: CustomAction, id?: string) => {
  const { actionConfiguration } = params;
  // we send headers as a map to backend but use it as an array on the frontend
  const headers = actionConfiguration?.headers?.reduce((acc, header) => {
    if (header.key) {
      // @ts-ignore
      acc[header.key] = header.value;
    }
    return acc;
  }, {}) as HeadersPayload;
  return {
    id,
    displayName: params.displayName,
    description: params.description,
    apiName: params.apiName,
    iconPath: params.iconPath,
    basicHelpText: params.basicHelpText,
    helpLink: params.helpLink,
    isBatch: actionConfiguration?.body?.isBatch,
    batchSize: actionConfiguration?.body?.batchSize,
    body: actionConfiguration?.body?.bodyValue,
    endpoint: actionConfiguration?.endpoint?.textValue,
    method: actionConfiguration?.endpoint?.selectValue,
    credentialId: actionConfiguration?.authentication?.credentialId,
    metadataId: actionConfiguration?.authentication?.metadataId,
    headers,
    variables: actionConfiguration?.variables,
  };
};

export const makeCustomActionPythonPayload = (params: any, id?: string): CustomActionPythonPayload => {
  const testCases = params.actionTesting?.testCases || params.tests;
  const tests = Array.isArray(testCases)
    ? testCases
        .map((testCase: any) => {
          // Already in backend format (id + inputData)
          if (testCase?.inputData && !testCase?.variableValues) {
            return { id: testCase.id, inputData: testCase.inputData };
          }
          // UI TestCase format with variableValues array
          const inputData: Record<string, any> = {};
          testCase?.variableValues?.forEach((variable: any) => {
            if (variable?.name) {
              inputData[variable.name] = variable.value;
            }
          });
          return {
            id: testCase?.persistedId || testCase?.id,
            inputData,
          };
        })
        .filter((test: any) => test.id || Object.keys(test.inputData || {}).length > 0)
    : undefined;

  return {
    id,
    displayName: params.displayName,
    description: params.description,
    apiName: params.apiName,
    iconPath: params.iconPath,
    helpText: params.basicHelpText,
    tags: params.tags,
    code: params.pythonCode,
    requirements: params.pythonRequirements,
    tests,
    inputVariables: params.variables?.map((variable: any) => ({
      name: variable.name,
      displayName: variable.displayName,
      helpText: variable.helpText,
      dataType: variable.dataType,
      // Convert string "true"/"false" to boolean
      multivalued: variable.multivalued === 'true' || variable.multivalued === true,
      required: variable.required === 'true' || variable.required === true,
    })),
  };
};
